<template>
  <div class="company_type_badge">
    <div v-if="companyType === 'Investor' || companyType === 'Allocator'" class="flex_horizontal">
      <SvgFactory name="icon_allocator" :width=16 color="allocator" />
      <span class="medium-overline-sm user_type_allocator">
        allocator</span>
    </div>
    <div v-else-if="companyType === 'Fund' || companyType === 'Manager'" class="flex_horizontal">
      <SvgFactory name="icon_manager" :width=16 color="manager" />
      <span class="medium-overline-sm user_type_manager">
        manager
      </span>
    </div>
    <div v-else-if="companyType === 'Service Provider'" class="flex_horizontal">
      <SvgFactory name="icon_serviceprovider" :width=16 color="serviceprovider" />
      <span class="medium-overline-sm user_type_service_provider">
        service provider
      </span>
    </div>
    <div v-else-if="companyType === 'Media'" class="flex_horizontal">
      <!-- TODO - Media/Press color changed from yellow to #07829D. We need to fix it ont he SVG Factory -->
      <SvgFactory name="icon_media" :width=16 customColor="#07829D" />
      <span class="medium-overline-sm user_type_media_press">
        media/press
      </span>
    </div>
    <div v-else-if="companyType === 'Guest'" class="flex_horizontal">
      <SvgFactory name="icon_guest" :width=16 color="guest" />
      <span class="medium-overline-sm user_type_guest">
        guest
      </span>
    </div>
    <div v-else-if="companyType === 'Speaker'" class="flex_horizontal">
      <SvgFactory name="icon_speaker" :width=16 color="speaker" />
      <span class="medium-overline-sm user_type_speaker">
        speaker
      </span>
    </div>
    <div v-else-if="companyType === 'Sponsor'" class="flex_horizontal">
      <SvgFactory name="icon_sponsor" :width=16 color="sponsor" />
      <span class="medium-overline-sm user_type_sponsor">
        sponsor
      </span>
    </div>
    <div v-else-if="companyType === 'iConnections' || companyType === 'Staff'" class="flex_horizontal">
      <SvgFactory name="icon_iconnections" :width=14 color="iconnections" />
      <span class="medium-overline-sm user_type_iconnections">
        iconnections
      </span>
    </div>
    <div v-else-if="companyType === 'Vendor'" class="flex_horizontal">
      <SvgFactory name="icon_vendor" :width=16 color="vendor" />
      <span class="medium-overline-sm user_type_vendor">
        vendor
      </span>
    </div>
    <div v-else  class="flex_horizontal">
      <SvgFactory name="icon_attendees" :width=16 :customColor="companyTypeColor" />
      <span class="medium-overline-sm" :style="color=`${companyTypeColor}`">
        {{ companyType }}
      </span>
    </div>
  </div>
</template>

<script>
import SvgFactory from '@design_system_v2/atoms/SvgFactory.vue';

export default {
  name: 'CompanyTypeBadge',
  components: {
    SvgFactory,
  },
  props: {
    companyType: String,
    companyTypeColor: String,
  },
};
</script>

<style lang="scss" scoped>
@import "@foundation";

.company_type_badge {
  display: flex;
  width: 100%;

  .iconn_svg {
    margin-top: -3px;
    margin-right: 4px;
  }

  span {
    text-transform: uppercase;
  }
}
</style>
